import React from 'react';
import { Select, SelectProps } from 'antd';

import { useQuery } from 'react-query';

import {
  getParPricingListByCriteria,
  GetParPricingListByCriteriaParams,
  ParPricingListResponse,
} from 'services/pricing';
import { noop } from 'lodash';

export type FormulaListProps = SelectProps<any> &{
  params: GetParPricingListByCriteriaParams;
  value?: ParPricingListResponse;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
};

const FormulaList = ({ params, value, onChange = noop , ...otherProps }: FormulaListProps) => {
  const { data: pricings } = useQuery(
    ['getParPricingListByCriteria', params],
    () => getParPricingListByCriteria(params).then((res) => res.list || [])
  );
  return (
    <Select value={(isNaN(Number(value))||Number(value)===0)?null:Number(value)} onChange={onChange} {...otherProps}>
      {pricings?.map((pricing) => (
        <Select.Option value={pricing.priid} key={pricing.priid}>
          {pricing.prilabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default FormulaList;
